import React, { ReactNode, useEffect, useState } from 'react'
import styles from '../styles/desnsitzeConfirm.module.scss'
import Dialog from '@/wmCompoments/dialog'
import { useTranslation } from 'react-i18next'

interface Props {
  visible: boolean
  onClose?: () => void
  className?: string
  onSubmit?: ()=>void
}

const DesnsitzeConfirm = (props: Props) => {
  const { visible, onClose, onSubmit } = props
  const { t } = useTranslation('accountManagement')
  return (
    <>
      <Dialog
        visible={visible}
        onClose={() => {
          props?.onClose?.()
        }}
        actions={[

          {
            key: 'cancel',
            text: t('cancel'),
            onClick: () => {
              onClose?.()
            }
          },
          {
            key: 'confirm',
            text: t('confirm'),
            onClick:  () => {
              onSubmit?.()
              onClose?.()
            }
          }
        ]}
        content={
          <div className={styles.dialog_content}>
            <span>{t('friendlyReminder')}</span>
            <span>{t('securityVerificationPrompt')}</span>
          </div>
        }
      />
    </>
  )
}

export default DesnsitzeConfirm
